import { NoticeBox } from "../NoticeBox";

const lines = (text) => (text || "").split("\n").map((l) => l.trim()).filter(Boolean);

function Box({ label, text, tone, testid }) {
  const items = lines(text);
  if (!items.length) return null;
  const cls = tone === "amber"
    ? "border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-900/60 border-l-amber-500"
    : tone === "slate"
      ? "border-border bg-muted/30 border-l-slate-400"
      : "border-border bg-card border-l-primary";
  const labelCls = tone === "amber" ? "text-amber-700 dark:text-amber-400" : tone === "slate" ? "text-muted-foreground" : "text-primary";
  return (
    <div className={`rounded-md border border-l-4 p-3 ${cls}`} data-testid={testid}>
      <p className={`text-[10px] uppercase tracking-[0.15em] font-semibold mb-1.5 ${labelCls}`}>{label}</p>
      <div className="text-xs text-foreground space-y-0.5">
        {items.map((l, i) => (/^[-*•]/.test(l)
          ? <p key={i} className="flex gap-1.5"><span className="text-muted-foreground">•</span><span>{l.replace(/^[-*•]\s*/, "")}</span></p>
          : <p key={i}>{l}</p>))}
      </div>
    </div>
  );
}

export function QuoteNarrative({ quote, showTerms = false, className = "" }) {
  if (!quote) return null;
  const notice = quote.notice?.text ? quote.notice : null;
  const has = notice || lines(quote.scope_of_works).length || lines(quote.caveats).length || (showTerms && lines(quote.terms).length);
  if (!has) return null;
  return (
    <div className={`space-y-3 ${className}`} data-testid="quote-narrative">
      {notice && notice.tone === "red" && <NoticeBox notice={notice} compact testid="quote-notice-box" />}
      <Box label="Scope of Works" text={quote.scope_of_works} tone="primary" testid="quote-scope-box" />
      <Box label="Caveats" text={quote.caveats} tone="amber" testid="quote-caveats-box" />
      {notice && notice.tone !== "red" && <NoticeBox notice={notice} compact testid="quote-notice-box" />}
      {showTerms && <Box label="Terms & Conditions" text={quote.terms} tone="slate" testid="quote-terms-box" />}
    </div>
  );
}
